import Model from '@models/model'
import { UI_FLAGS } from '@src/graphql/uiFlags'
import { UiFlagsStoreState } from './types'
import reducers from './reducers'

export default class UiFlags {
  namespace = 'uiFlags'

  state: UiFlagsStoreState = {
    ...Model.defaultState,
    uiFlags: {},
  }

  effects = {
    fetch: Model.buildEffect({
      name: `${this.namespace}/fetch`,
      query: UI_FLAGS,
      dataPath: 'uiFlags',
      reducers: [{ name: 'setUiFlags' }],
    }),
  }

  reducers = reducers
}
